const app = angular.module('msi.core', [
  'ngCookies',
  'ngMessageFormat',
  require('./constants'),
  require('./config')
]);


module.exports = app.name;
